import React, { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { branchlist, desilist, rolelist } from "../../../services/master";
import moment from "moment/moment";
import { createstaff, viewstaff } from "../../../services/admin";
import ImageUrl from "../../../ImageUrl";
import { STAFF_ASSIGNABLE_ROLES } from "../../../utils/roles";

export default function Addstaff() {
    const navigate = useNavigate();
    const [urllink, setUrllink] = useState("");
    const { id } = useParams();
    const [sname, setSName] = useState("");
    const [scode, setSCode] = useState("");
    const [dob, setDob] = useState("");
    const [gender, setGender] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [fname, setFName] = useState("");
    const [jdate, setJoin] = useState("");

    const [blist, setBlist] = useState([]);
    const [branch, setBranch] = useState([]);
    const [dlist, setDlist] = useState([]);
    const [desig, setDesig] = useState("");
    const [ulist, setUlist] = useState([]);
    const [urole, setUrole] = useState("");
    const [addr, setAddr] = useState("");
    const [dist, setDist] = useState("");
    const [pin, setPin] = useState("");

    const [pan, setPan] = useState("");
    const [accno, setAccno] = useState("");
    const [pfacc, setPfacc] = useState("");
    const [pfuan, setPfuan] = useState("");
    const [esino, setEsino] = useState("");
    const [taxregime, setTaxregime] = useState("");
    const [locate, setLocate] = useState("");
    const [leavedate, setLeavedate] = useState("");

    const [uname, setUName] = useState("");
    const [pass, setPass] = useState("");

    function LetterOnly(eve) {
        if (/^[a-zA-Z\s]*$/.test(eve.key)) {
            return true;
        } else {
            eve.preventDefault();
            return false;
        }
    }

    function onPasteLetter(e) {
        const str = e.clipboardData.getData("Text");
        const newStr = str.replace(/[+-.]/g, "");
        if (str !== newStr) {
            e.preventDefault();
        }
    }
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split("/")[2];
        setUrllink(path);

        branchlist().then((res) => {
            if (res.status === true) {
                if (res.data.length !== 0) {
                    let arr = [];
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].branch_name
                        })
                    }
                    setBlist(arr);
                }
            }
        });

        desilist().then((res) => {
            if (res.status === true) {
                setDlist(res.data);
            }
        });

        rolelist().then((res) => {
            if (res.status === true) {
                // Only Admin / Manager / Employee are assignable to staff.
                const roles = Array.isArray(res.data) ? res.data : [];
                setUlist(
                    roles.filter((r) =>
                        STAFF_ASSIGNABLE_ROLES.includes(String(r.id))
                    )
                );
            }
        });

        if (path === "staffdetail") {
            viewstaff(id).then((res) => {
                if (res.status === true) {
                    if (res.data.details !== null) {
                        setSName(res.data.details.staff_name);
                        setSCode(res.data.details.staff_code);
                        setDob(res.data.details.date_of_birth);
                        setGender(res.data.details.gender);
                        setEmail(res.data.details.email);
                        setPhone(res.data.details.phone);
                        setFName(res.data.details.father_name);
                        setJoin(res.data.details.joining_date);
                        setDesig(res.data.details.designation_id);
                        setUrole(res.data.details.role_id);
                        setAddr(res.data.details.address);
                        setDist(res.data.details.district);
                        setPin(res.data.details.pincode);
                        setPan(res.data.details.pan ?? "");
                        setAccno(res.data.details.account_number ?? "");
                        setPfacc(res.data.details.pf_account_number ?? "");
                        setPfuan(res.data.details.pf_uan ?? "");
                        setEsino(res.data.details.esi_number ?? "");
                        setTaxregime(res.data.details.tax_regime ?? "");
                        setLocate(res.data.details.location ?? "");
                        setLeavedate(res.data.details.leaving_date ?? "");
                        setUName(res.data.details.username);
                        setPass(res.data.details.password);
                        if (res.data.details.photo !== null) {
                            setPUrl(ImageUrl + res.data.path + res.data.details.photo);
                        }

                        branchlist().then((resp) => {
                            if (resp.status === true) {
                                if (resp.data.length !== 0) {
                                    let arr = [];
                                    let branchIds = res.data.details.branch_id.split(',');
                                    for (let i = 0; i < resp.data.length; i++) {
                                        if (branchIds.includes(String(resp.data[i].id))) {
                                            arr.push({
                                                value: resp.data[i].id,
                                                label: resp.data[i].branch_name
                                            });
                                        }

                                    }
                                    setBranch(arr);
                                }
                            }
                        });
                    }
                }
            })
        } else {
            setJoin(moment(new Date()).format("YYYY-MM-DD"));
            setSName("");
            setSCode("");
            setDob("");
            setGender("");
            setEmail("");
            setPhone("");
            setFName("");
            setJoin("");
            setBranch([]);
            setDesig("");
            setUrole("");
            setAddr("");
            setDist("");
            setPin("");
            setPan("");
            setAccno("");
            setPfacc("");
            setPfuan("");
            setEsino("");
            setTaxregime("");
            setLocate("");
            setLeavedate("");
            setPUrl("");
            setUName("");
            setPass("");
        }
    }, [location.pathname]);

    const [photoerror, setPhotoError] = useState("");
    const [purl, setPUrl] = useState("");
    const [pfile, setPFile] = useState("");
    function photofile(event) {
        setPhotoError("");
        setPFile("");
        setPUrl("");
        if (event.target.files.length !== 0) {
            if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
                setPUrl(URL.createObjectURL(event.target.files[0]));
                setPFile(event.target.files[0]);
            } else {
                setPhotoError("Photo should be jpg, jpeg, or png format");
            }
            var size = event.target.files[0].size / 1024 / 1024;
            if (size > 5) {
                setPhotoError("Photo size should be less than 5MB");
            }
        }
    }

    function errorphoto(ev) {
        ev.target.src = require("../../../assets/images/teacher.jpg");
        ev.target.onerror = null;
    }
    const handleChange = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setPhone(e.target.value);
        }
    };



    const handlePincode = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setPin(e.target.value);
        }
    };

    function handleBranch(e) {
        if (e !== null) {
            setBranch(e);
        } else {
            setBranch([]);
        }
    }

    const [errmsg, setError] = useState("");
    const [successmsg, setSuccess] = useState(false);
    function handlesubmit(e) {
        e.preventDefault();
        setSuccess(true);
        var valid = "";
        if (phone !== "") {
            if (phone.length < 10) {
                valid = "Phone Number should be 10 digits";
                setError("Phone Number should be 10 digits");
            }
        }

        if (pin !== "") {
            if (pin.length < 6) {
                valid = "Pincode should be 6 digits";
                setError("Pincode should be 6 digits");
            }
        }



        if (
            valid === "" &&
            sname !== "" &&
            scode !== "" &&
            gender !== "" &&
            dob !== "" &&
            email !== "" &&
            phone !== "" &&
            fname !== "" &&
            jdate !== "" &&
            branch.length !== 0 &&
            desig !== "" &&
            urole !== "" &&
            addr !== "" &&
            dist !== "" &&
            pin !== ""
        ) {
            setLoading(true);
            let bra = "";
            if (branch.length !== 0) {
                for (let i = 0; i < branch.length; i++) {
                    if (i === 0) {
                        bra = branch[i].value;
                    } else {
                        bra = bra + "," + branch[i].value;
                    }
                }
            }

            const temp = new FormData();
            temp.append("staff_name", sname);
            temp.append("staff_code", scode);
            temp.append("date_of_birth", dob);
            temp.append("gender", gender);
            temp.append("email", email);
            temp.append("phone", phone);
            temp.append("father_name", fname);
            temp.append("joining_date", jdate);
            temp.append("branch_id", bra);
            temp.append("designation_id", desig);
            temp.append("role_id", urole);
            temp.append("address", addr);
            temp.append("district", dist);
            temp.append("pincode", pin);
            temp.append("pan", pan);
            temp.append("account_number", accno);
            temp.append("pf_account_number", pfacc);
            temp.append("pf_uan", pfuan);
            temp.append("esi_number", esino);
            temp.append("tax_regime", taxregime);
            temp.append("location", locate);
            temp.append("leaving_date", leavedate);
            if (urllink === "addstaff") {
                temp.append("photo", pfile);
            } else {
                temp.append("id", id);
                if (pfile !== "") {
                    temp.append("photo", pfile);
                }
            }
            createstaff(temp).then((res) => {
                if (res.status === true) {
                    setLoading(false);
                    toast.success(res.message);
                    navigate("/staff/allstaff");
                } else {
                    setLoading(false);
                    toast.error(res.message);
                }
            })
        }
    }
    const [loading, setLoading] = useState(false);


    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">{urllink === "addstaff" ? "Add Staff" : "Staff Detail"}</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Staff</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {urllink === "addstaff" ? "Add Staff" : "Staff Detail"}
                    </li>
                </ol>


            </div>

            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <h2 className="main-content-title tx-24 mg-b-5">
                                        {urllink === "addstaff" ? "Add Staff" : "Staff Detail"}
                                    </h2>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-xl-3 col-lg-4">
                                            <label className="form-label ">Photo</label>
                                            <div className="avatar-upload">
                                                <div className="avatar-preview">
                                                    <img
                                                        src={purl}
                                                        onError={(e) => errorphoto(e)}
                                                        alt="staff image"
                                                    />
                                                </div>
                                                <div className="change-btn mt-2 mb-lg-0 mb-3">
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept=".png, .jpg, .jpeg"
                                                        onChange={(e) => photofile(e)}
                                                    />
                                                    {photoerror !== "" && (
                                                        <span className="text-danger">{photoerror}</span>
                                                    )}
                                                    <a
                                                        className="btn btn-secondary my-2"
                                                        onClick={() => {
                                                            setPUrl("");
                                                            setPFile("");
                                                        }}
                                                    >
                                                        Remove
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-9 col-lg-8">
                                            <div className="row">
                                                {urllink === "staffdetail" &&
                                                    <>
                                                        <div className="col-xl-6 col-sm-6">
                                                            <div className="mb-3">
                                                                <div className="username-field">
                                                                    Username : {uname}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-6 col-sm-6">
                                                            <div className="mb-3">
                                                                <div className="password-field">
                                                                    Password : {pass}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>

                                                }
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Staff Name
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Staff Name"
                                                            value={sname}
                                                            onChange={(e) => setSName(e.target.value)}
                                                            onKeyPress={LetterOnly}
                                                            onPaste={onPasteLetter}
                                                        />
                                                        {successmsg && sname === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Staff Name
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Staff Code
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Staff Code"
                                                            value={scode}
                                                            onChange={(e) => setSCode(e.target.value)}
                                                        />
                                                        {successmsg && scode === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Staff Code
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Date Of Birth
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                value={dob}
                                                                onChange={(e) => setDob(e.target.value)}
                                                                onKeyPress={(event) => {
                                                                    event.preventDefault();
                                                                }}
                                                                onKeyDown={(event) => {
                                                                    event.preventDefault();
                                                                }}
                                                            />

                                                        </div>
                                                        {successmsg && dob === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Date Of Birth
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Gender<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="default-select form-control wide"
                                                            value={gender}
                                                            onChange={(e) => setGender(e.target.value)}
                                                        >
                                                            <option value="" disabled>
                                                                Select Gender
                                                            </option>
                                                            <option value={"Male"}>Male</option>
                                                            <option value={"Female"}>Female</option>
                                                            <option value={"Others"}>Others</option>
                                                        </select>
                                                        {successmsg && gender === "" && (
                                                            <span className="text-danger">
                                                                Please Select Gender
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Email<span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="Enter EMail"
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            onPaste={(e) => {
                                                                e.preventDefault();
                                                                return false;
                                                            }}
                                                            onCopy={(e) => {
                                                                e.preventDefault();
                                                                return false;
                                                            }}
                                                        />
                                                        {successmsg && email === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Email
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Mobile Number<span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Mobile"
                                                            value={phone}
                                                            maxLength={10}
                                                            onChange={(e) => setPhone(e.target.value)}
                                                            onPaste={(e) => {
                                                                e.preventDefault();
                                                                return false;
                                                            }}
                                                            onCopy={(e) => {
                                                                e.preventDefault();
                                                                return false;
                                                            }}
                                                        />
                                                        {phone !== "" && phone.length < 10 && (
                                                            <span className="text-danger">Mobile Number should be 10 digits</span>
                                                        )}
                                                        {successmsg && phone === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Mobile Number
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Father Name
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Father Name"
                                                            onKeyPress={LetterOnly}
                                                            onPaste={onPasteLetter}
                                                            value={fname}
                                                            onChange={(e) => setFName(e.target.value)}
                                                        />
                                                        {successmsg && fname === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Father Name
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Joining Date
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                value={jdate}
                                                                onChange={(e) => setJoin(e.target.value)}
                                                                onKeyPress={(event) => {
                                                                    event.preventDefault();
                                                                }}
                                                                onKeyDown={(event) => {
                                                                    event.preventDefault();
                                                                }}
                                                            />

                                                        </div>
                                                        {successmsg && jdate === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Joining Date
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Select Branch<span className="text-danger"> *</span>
                                                        </label>
                                                        <Select
                                                            className="default-select"
                                                            placeholder="Select Branch"
                                                            value={branch}
                                                            options={blist}
                                                            onChange={handleBranch}
                                                            isSearchable={true}
                                                            isMulti
                                                            isClearable
                                                            hidden
                                                        />

                                                        {successmsg && branch.length === 0 && (
                                                            <span className="text-danger">
                                                                Please Select Branch
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Designation<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="default-select form-control wide"
                                                            value={desig}
                                                            onChange={(e) => setDesig(e.target.value)}
                                                        >
                                                            <option value="" disabled>
                                                                Select Designation
                                                            </option>
                                                            {dlist.map((item) => {
                                                                return (
                                                                    <option key={item.id} value={item.id}>
                                                                        {item.designation_name}
                                                                    </option>
                                                                )
                                                            })}
                                                        </select>
                                                        {successmsg && desig === "" && (
                                                            <span className="text-danger">
                                                                Please Select Designation
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            User Role<span className="text-danger"> *</span>
                                                        </label>
                                                        <select
                                                            className="default-select form-control wide"
                                                            value={urole}
                                                            onChange={(e) => setUrole(e.target.value)}
                                                        >
                                                            <option value="" disabled>
                                                                Select User Role
                                                            </option>
                                                            {ulist.map((item) => {
                                                                return (
                                                                    <option key={item.id} value={item.id}>
                                                                        {item.role_name}
                                                                    </option>
                                                                )
                                                            })}
                                                        </select>
                                                        {successmsg && urole === "" && (
                                                            <span className="text-danger">
                                                                Please Select User Role
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Address<span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Address"
                                                            value={addr}
                                                            onChange={(e) => setAddr(e.target.value)}
                                                        />
                                                        {successmsg && addr === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Address
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            District<span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter District"
                                                            value={dist}
                                                            onChange={(e) => setDist(e.target.value)}
                                                        />
                                                        {successmsg && dist === "" && (
                                                            <span className="text-danger">
                                                                Please Enter District
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Pincode<span className="text-danger"> *</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Pincode"
                                                            maxLength={6}
                                                            value={pin}
                                                            onChange={handlePincode}
                                                        />
                                                        {successmsg && pin === "" && (
                                                            <span className="text-danger">
                                                                Please Enter Pincode
                                                            </span>
                                                        )}
                                                        {pin !== "" && pin.length < 6 && (
                                                            <span className="text-danger">
                                                                Pincode should be 6 digits
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">PAN</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter PAN"
                                                            value={pan}
                                                            onChange={(e) => setPan(e.target.value.toUpperCase())}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Bank Account Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Account Number"
                                                            value={accno}
                                                            onChange={(e) => setAccno(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">PF Account Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter PF Account Number"
                                                            value={pfacc}
                                                            onChange={(e) => setPfacc(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">PF UAN</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter PF UAN"
                                                            value={pfuan}
                                                            onChange={(e) => setPfuan(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">ESI Number</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter ESI Number"
                                                            value={esino}
                                                            onChange={(e) => setEsino(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Tax Regime</label>
                                                        <select
                                                            className="default-select form-control wide"
                                                            value={taxregime}
                                                            onChange={(e) => setTaxregime(e.target.value)}
                                                        >
                                                            <option value="">Select Tax Regime</option>
                                                            <option value={"NEW"}>NEW</option>
                                                            <option value={"OLD"}>OLD</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Location</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Location"
                                                            value={locate}
                                                            onChange={(e) => setLocate(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Leaving Date</label>
                                                        <div className="input-group">
                                                            <input
                                                                className="form-control"
                                                                type="date"
                                                                value={leavedate}
                                                                onChange={(e) => setLeavedate(e.target.value)}
                                                                onKeyPress={(event) => {
                                                                    event.preventDefault();
                                                                }}
                                                                onKeyDown={(event) => {
                                                                    event.preventDefault();
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <div className="text-right">
                                            <a
                                                className="btn btn-success me-2"
                                                onClick={(e) => handlesubmit(e)}
                                            >
                                                {urllink === "addstaff" ? "Submit" : "Update"}
                                            </a>
                                            <a className="btn btn-secondary" onClick={() => navigate("/staff/allstaff")}> Back</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
